export default __webpack_public_path__ + "static/media/city.51f47292.png";